<template>
  <div class="container order-detail-container">
    <div class="base-info checkin-base-info">
      <div class="base-h"><strong>值机订单信息</strong></div>
      <div class="base-m">
        <table class="base-info-table">
          <tr>
            <td width="300">
              <span class="_info-t">订单号：</span>
              <span class="_info-m r">{{ seatOrderNo || '--' }}</span>
            </td>
          </tr>
          <tr>
            <td width="300">
              <span class="_info-t">订单状态：</span>
              <span class="_info-m r">{{ detail.statusCn || '--' }}</span>
            </td>
            <td>
              <span class="_info-t">订单金额：</span>
              <span class="_info-m r">{{ detail.seatPrice }}元</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="_info-t">预定日期：</span>
              <span class="_info-m">{{ moment(detail.createTime).format('YYYY-MM-DD') || '--'  }}</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!--旅客信息-->
    <div class="order-detail-row">
      <div class="detail-header">
        <span class="header-m">旅客</span>
        <span class="header-m">{{ detail.passengerChnName }}</span>
        <span class="header-sub"><span class="_sub-title">{{ detail.idtypeCn }} </span><span>{{ detail.certId }}</span> </span>
        <span class="header-sub"><span class="_sub-title">手机</span><span>{{ detail.moblieNo || '--'}}</span>  </span>
        <span class="header-sub"><span class="_sub-title">票号</span><span>{{ detail.ticketNo }}</span>  </span>
      </div>
      <a-table class="detail-table l8-gray-table"
               :dataSource='passengerData'
               :columns='passengerCols'
               :pagination='false'
      />
    </div>
    <!--办理人-->
    <div class="order-detail-row">
      <div class="detail-header">
        <span>办理人信息</span>
      </div>
      <a-table class="detail-table l8-gray-table"
               :dataSource='contactData'
               :columns='contactCols'
               :pagination='false'
      />
    </div>
    <div class="chekcin-notice-row">
      <p>因款项信息以窗口信息发送，购票时请关闭广告窗口拦截工具</p>
      <p class="notice-strong">操作说明</p>
      <p class="notice-p">取消值机：可对值机操作进行取消，若您已进行支付，我们将在审核通过后为您退换到支付银行中。</p>
      <p class="notice-p">保存登机牌：点击“保存登机牌”按钮讲登机牌保存本地稍候打印。</p>
      <!--<p class="notice-p">关闭窗口：关闭弹出窗口。</p>-->
    </div>
    <!--订单操作-->
    <div class="order-action-row">
      <a-button v-if="showActionCancel" type="primary" @click="cancelHandler">取消值机</a-button>
      <!--<a-button type="primary" @click="closeHandler">关闭窗口</a-button>-->
    </div>
    <!--取消弹窗-->
    <a-modal
      title="提示"
      v-model="cancelModVisible"
      wrapClassName="order-modal"
      :okText="'确定'"
      :cancelText="'取消'"
      :closable="false"
      :confirmLoading="cancelConfirmLoading"
      @ok="cancelConfirmHandler"
    >
      确定取消值机？
    </a-modal>
  </div>
</template>

<script>
import queryString from 'query-string'
import { queryCheckinDetail, checkinCancel } from '@/apis/checkin'
import '@/assets/css/l8-order-common.less'
import getAppInfo from '@/utils/from'

import '@/components/l8-icon'

const passengerCols = [
  {
    title: '行程',
    dataIndex: 'segment',
    key: 'segment'
  },
  {
    title: '承运人',
    dataIndex: 'airlineCode',
    key: 'airlineCode'
  },
  {
    title: '航班日期',
    dataIndex: 'flightDate',
    key: 'flightDate'
  },
  {
    title: '航班号',
    dataIndex: 'flightNo',
    key: 'flightNo'
  },
  {
    title: '起飞时间',
    dataIndex: 'flightTime',
    key: 'flightTime'
  },
  {
    title: '舱位',
    dataIndex: 'seatClass',
    key: 'seatClass'
  },
  {
    title: '座位号',
    dataIndex: 'seatNumber',
    key: 'seatNumber'
  }
]

const contactCols = [
  {
    title: '预订用户姓名',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    key: 'phone'
  },
  {
    title: '预定用户账号',
    dataIndex: 'userId',
    key: 'userId'
  },
  {
    title: '预定时间',
    dataIndex: 'createTime',
    key: 'createTime'
  }
]

const idTypeMap = {
  'NI': '身份证',
  'PP': '护照',
  'TN': '电子客票号'
}

export default {
  data () {
    return {
      // 订单基本信息
      seatOrderId: '',
      seatOrderNo: '',
      totalAmount: '',
      detail: {},
      // 其他信息
      passengerData: [],
      passengerCols: passengerCols,
      contactData: [],
      contactCols: contactCols,

      cancelConfirmLoading: false,
      cancelModVisible: false,
      showActionCancel: true
    }
  },
  watch: {

  },
  created () {
    let query = queryString.parse(location.search)

    this.seatOrderId = query.seatOrderId

    this.fetchOrder()
  },
  methods: {
    async fetchOrder () {
      try {
        const res = await queryCheckinDetail({
          id: this.seatOrderId
        })

        this.updateOrderDetail(res)
      } catch (err) {
        this.$message.error(err.message || '订单查询失败，请稍后再试', () => {
          this.$router.replace({ path: '/checkin/search' })
        })
      }
    },
    updateOrderDetail (detail) {
      detail.idTypeCn = idTypeMap[detail.idType]

      this.detail = detail
      this.seatOrderNo = detail.seatOrderNo

      this.updateExtendInfo()
    },
    updateExtendInfo () {
      this.updatePassData(this.detail)
      this.updateContact(this.detail)
      this.updateOrderActions(this.detail.status)
    },
    updateOrderActions (status) {
      switch (status) {
        case 'WP': // 等待支付
          this.showActionCancel = true
          break
        case 'PF': // 已出票
          this.showActionCancel = true
          break
        case 'HP': // 支付未出票
          this.showActionCancel = true
          break
        case 'XX': // 已取消
          this.showActionCancel = false
          break
        case 'WF': // 等待确认乘客
          this.showActionCancel = false
          break
        default :
          this.showActionCancel = true
      }
    },
    updateContact (detail) {
      this.contactData = [
        {
          key: '1',
          username: detail.user.chiName,
          phone: detail.user.dtoUserInfo.mobileNo,
          userId: detail.user.loginid,
          createTime: this.moment(detail.createTime).format('YYYY-MM-DD HH:mm')
        }
      ]
    },
    updatePassData (detail) {
      this.passengerData = [
        {
          key: '1',
          segment: detail.depName + '-' + detail.arrName,
          airlineCode: detail.airlineCode === window.__MICRO_ROOT__?.airline ? getAppInfo()?.name : detail.airlineCode,
          flightDate: this.moment(detail.flightDate).format('YYYY-MM-DD'),
          flightNo: detail.flightNo,
          flightTime: this.moment(detail.flightDate).format('HH:mm'),
          seatClass: detail.seatClass,
          seatNumber: detail.seatNumber
        }
      ]
    },
    cancelHandler () {
      this.cancelModVisible = true
    },
    cancelConfirmHandler () {
      this.cancelConfirmLoading = true

      let params = {
        'airline': this.detail.airlineCode,
        'arrCode': this.detail.arrCode,
        'boardingNumber': this.detail.boardingNumber,
        'cabin': this.detail.seatClass,
        'depCode': this.detail.depCode,
        'depTime': this.moment(this.detail.flightDate).format('YYYY-MM-DD'),
        'flightNo': this.detail.flightNo,
        'passengerName': this.detail.passengerChnName,
        'seatNumber': this.detail.seatNumber,
        'ticketNo': this.detail.ticketNo,
        'tourIndex': this.detail.tourIndex
      }

      checkinCancel(params).then((res) => {
        this.cancelConfirmLoading = false
        this.cancelModVisible = false
        this.$message.success('值机取消成功，正在刷新页面。')
        setTimeout(function () {
          window.location.reload()
        }, 2000)
      }).catch((err) => {
        this.cancelConfirmLoading = false
        this.cancelModVisible = false
        this.$message.error(err.message || '值机取消失败，请稍后再试')
      })
    }
  }
}
</script>

<style lang="less">
  .order-detail-container {
    padding-top: 50px;
  }

  .base-h {
    font-size: 24px;
    margin-bottom: 20px;

    strong {
      margin-right: 20px;
    }
  }

  .base-m {
    background: #fff;
    padding: 10px 18px;
  }

  .base-info-table {
    font-size: 12px;
    width: 100%;
  }

  .base-info-table tr td {
    padding: 5px 0;
  }

  .base-info-table ._info-t {
    word-break: break-all;
    white-space: nowrap;
    display: block;
  }

  .base-info-table ._info-m {
    word-break: keep-all;
  }

  .base-info-table ._info-m.r {
    color: @primary-color;
    font-weight: bold;
  }

  .base-info-table ._info-m.r-large {
    color: @primary-color;
    font-weight: bold;
    font-size: 16px;
  }

  .checkin-base-info {
    .base-m {
      padding: 10px 0;
    }

    .base-info-table {
      font-size: 14px;
      width: 100%;
    }

    .base-info-table ._info-t {
      display: inline;
    }
  }

  /*订单信息row*/
  .order-detail-row {
    margin-top: 10px;
  }

  .order-detail-row + .order-detail-row {
    margin-top: 60px;
  }

  .detail-header {
    font-size: 22px;
    padding: 5px 0;
    border-bottom: 1px solid #808080;
    margin-bottom: 20px;

    .header-m {
      margin-right: 10px;
    }

    .header-sub {
      font-size: 14px;
      margin: 0 20px;
      ._sub-title {
        margin-right: 5px;
      }
    }
  }

  .detail-header .l8-icon {
    margin-right: 5px;
  }

  .detail-table {
    font-size: 12px;
  }

  .order-detail-container .passenger-seg-list {
    margin-top: 20px;
  }

  /*订单操作*/
  .order-action-row {
    padding: 60px 0;
    text-align: center;

    .ant-btn {
      width: 120px;
      height: 50px;

      + .ant-btn {
        margin-left: 54px;
      }
    }

  }

  .chekcin-notice-row {
    font-size: 14px;
    margin-top: 38px;
    line-height: 30px;
  }

  .notice-strong {
    font-size: 16px;
    font-weight: bold;
  }

  .notice-p {
    text-indent: 20px;
  }

  @media only screen and (max-width: 768px) {
    .detail-table {
      overflow-x: scroll;
      word-break: break-all;
      white-space: nowrap;
    }

    .order-action-row {
      padding: 60px 10px;
    }

    .order-action-row .ant-btn {
      width: 100%;
    }

    .order-action-row .ant-btn + .ant-btn {
      margin-left: 0;
      margin-top: 10px;
    }
  }
</style>
